import React from 'react';

const prefix = 'nxt';
const iconName = 'offline';
const width = 10;
const height = 10;
const unicode = '';
const svgPathData = '';

const definition = {
  prefix: prefix,
  nxtCustom: true,
  iconName: iconName,
  icon: [width, height, unicode, svgPathData],
  iconDom: (
    <>
      <circle cx="5" cy="5" fill="none" r="4" stroke="#758BA3" strokeWidth="1.75" />
    </>
  ),
};

const nxtOffline = definition;

export { definition, nxtOffline, prefix, iconName, width, height, unicode, svgPathData };
